// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1yaLZ","selected":"Chip_selected__3Jyk1"};